import i18n from 'shared/lib/i18n';

import {
  CLEAR_AMENITIES,
  CREATE_AMENITY_FAILURE,
  CREATE_AMENITY_REQUEST,
  CREATE_AMENITY_SUCCESS,
  DELETE_AMENITY_IMAGE,
  DELETE_AMENITY_IMAGE_FAILURE,
  DELETE_AMENITY_IMAGE_SUCCESS,
  GET_ALLOWED_HOURS_FAILURE,
  GET_ALLOWED_HOURS_REQUEST,
  GET_ALLOWED_HOURS_SUCCESS,
  GET_AMENITIES_FAILURE,
  GET_AMENITIES_REQUEST,
  GET_AMENITIES_SUCCESS,
  GET_AMENITY_FAILURE,
  GET_AMENITY_REQUEST,
  GET_AMENITY_RESERVATIONS_FAILURE,
  GET_AMENITY_RESERVATIONS_REQUEST,
  GET_AMENITY_RESERVATIONS_SUCCESS,
  GET_AMENITY_RESERVATION_FAILURE,
  GET_AMENITY_RESERVATION_REQUEST,
  GET_AMENITY_RESERVATION_SUCCESS,
  GET_AMENITY_SUCCESS,
  GET_CALENDAR_EVENTS,
  GET_DOORS_AMENITY_FAILURE,
  GET_DOORS_AMENITY_REQUEST,
  GET_DOORS_AMENITY_SUCCESS,
  GET_ITEMS_FOR_EXPORT_SUCCESS,
  GET_RESERVED_DATES_FAILURE,
  GET_RESERVED_DATES_REQUEST,
  GET_RESERVED_DATES_SUCCESS,
  REMOVE_AMENITY_FAILURE,
  REMOVE_AMENITY_REQUEST,
  REMOVE_AMENITY_SUCCESS,
  REMOVE_RESERVATION_FAILURE,
  REMOVE_RESERVATION_REQUEST,
  REMOVE_RESERVATION_SUCCESS,
  RESERVE_AMENITY_FAILURE,
  RESERVE_AMENITY_REQUEST,
  RESERVE_AMENITY_SUCCESS,
  SET_AMENITY_STATUS_FAILURE,
  SET_AMENITY_STATUS_REQUEST,
  SET_AMENITY_STATUS_SUCCESS,
  SET_CALENDAR_EVENTS,
  SET_MODAL_TYPE,
  UPDATE_AMENITY_FAILURE,
  UPDATE_AMENITY_REQUEST,
  UPDATE_AMENITY_RESERVATION_FAILURE,
  UPDATE_AMENITY_RESERVATION_REQUEST,
  UPDATE_AMENITY_RESERVATION_SUCCESS,
  UPDATE_AMENITY_SUCCESS,
} from '../../actionConstants';
import { showCalendarPlaceholders } from '../Calendar/actions';
import { notifyUser } from '../Main/actions';
import { uploadImage } from '../Visitor/actionCreators';

import { getTodayCount } from '../../utils';
import { sendGA4Event } from '../Shared/utils/ga';
import { formatReservationsEvents } from './utils';

import apiClient from '../../apiClient';
import { history } from '../../store';
import { CONFIRM } from '../Modal/modalTypes';

export const onGetReservationsCalendar = (dispatch, queryParams) => {
  showCalendarPlaceholders(dispatch, queryParams);
  return dispatch({
    type: GET_CALENDAR_EVENTS,
    withoutLoading: true,
    payload: apiClient.amenity.getReservationsCalendar(queryParams).then(
      (res) => {
        dispatch({
          type: SET_CALENDAR_EVENTS,
          events: formatReservationsEvents(res?.data),
        });
        return res;
      },
      (err) => {
        dispatch({
          type: SET_CALENDAR_EVENTS,
          events: [],
        });
        return err;
      },
    ),
  });
};

export const getAmenityReservations = (dispatch, queryParams, isExport) =>
  dispatch({
    type: GET_AMENITY_RESERVATIONS_REQUEST,
    withoutLoading: isExport,
    payload: apiClient.amenity.getReservations(queryParams).then(
      (res) => {
        dispatch({
          type: isExport
            ? GET_ITEMS_FOR_EXPORT_SUCCESS
            : GET_AMENITY_RESERVATIONS_SUCCESS,
          res,
        });
        return res;
      },
      (err) => {
        dispatch({
          type: GET_AMENITY_RESERVATIONS_FAILURE,
          err,
        });
        return err;
      },
    ),
  });

export const getAmenityReservation = (dispatch, reservationId) =>
  dispatch({
    type: GET_AMENITY_RESERVATION_REQUEST,
    payload: apiClient.amenity.getReservation(reservationId).then(
      (res) => {
        dispatch({
          type: GET_AMENITY_RESERVATION_SUCCESS,
          res,
        });
        return res;
      },
      (err) => {
        dispatch({
          type: GET_AMENITY_RESERVATION_FAILURE,
          err,
        });
        return err;
      },
    ),
  });

export const getAmenities = (dispatch, queryParams, isExport) =>
  dispatch({
    type: GET_AMENITIES_REQUEST,
    withoutLoading: isExport,
    payload: apiClient.amenity.getAmenities(queryParams).then(
      (res) => {
        dispatch({
          type: isExport ? GET_ITEMS_FOR_EXPORT_SUCCESS : GET_AMENITIES_SUCCESS,
          res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_AMENITIES_FAILURE,
          err,
        }),
    ),
  });

export const getAmenity = (dispatch, amenityId) =>
  dispatch({
    type: GET_AMENITY_REQUEST,
    payload: apiClient.amenity.getAmenity(amenityId).then(
      (res) =>
        dispatch({
          type: GET_AMENITY_SUCCESS,
          amenityId,
          res,
        }),
      (err) =>
        dispatch({
          type: GET_AMENITY_FAILURE,
          err,
        }),
    ),
  });

export const reserveAmenity = (dispatch, amenityId, data) =>
  dispatch({
    type: RESERVE_AMENITY_REQUEST,
    isForm: true,
    payload: apiClient.amenity.reserveAmenity(amenityId, data).then(
      (res) => {
        sendGA4Event('created_amenity_reservation');
        dispatch({
          type: RESERVE_AMENITY_SUCCESS,
          res,
        });
        return history.goBack();
      },
      (err) => {
        dispatch({
          type: RESERVE_AMENITY_FAILURE,
          err,
        });
        return err;
      },
    ),
  });

export const updateAmenityReservation = (dispatch, reservationId, data) =>
  dispatch({
    type: UPDATE_AMENITY_RESERVATION_REQUEST,
    isForm: true,
    payload: apiClient.amenity.updateReservation(reservationId, data).then(
      (res) => {
        dispatch({
          type: UPDATE_AMENITY_RESERVATION_SUCCESS,
          res,
        });
        return history.goBack();
      },
      (err) => {
        dispatch({
          type: UPDATE_AMENITY_RESERVATION_FAILURE,
          err,
        });
        return err;
      },
    ),
  });

export const removeReservation = (dispatch, data) =>
  dispatch({
    type: REMOVE_RESERVATION_REQUEST,
    payload: apiClient.amenity.removeReservation(data?.id).then(
      (res) => {
        dispatch({
          type: REMOVE_RESERVATION_SUCCESS,
          res,
        });
        getAmenityReservations(dispatch, data?.listParams);
        return getTodayCount(
          getAmenityReservations,
          dispatch,
          data?.listParams,
        );
      },
      (err) =>
        dispatch({
          type: REMOVE_RESERVATION_FAILURE,
          err,
        }),
    ),
  });

export const removeAmenity = (dispatch, data) =>
  dispatch({
    type: REMOVE_AMENITY_REQUEST,
    payload: apiClient.amenity.removeAmenity(data?.id).then(
      (res) => {
        dispatch({
          type: REMOVE_AMENITY_SUCCESS,
          res,
        });
        return history.goBack();
      },
      (err) =>
        dispatch({
          type: REMOVE_AMENITY_FAILURE,
          err,
        }),
    ),
  });

export const getReservedDates = (dispatch, amenityId) =>
  dispatch({
    type: GET_RESERVED_DATES_REQUEST,
    payload: apiClient.amenity.getReservedDates(amenityId).then(
      (res) => {
        if (!res?.data?.hasAvailableDates)
          notifyUser(
            dispatch,
            i18n.t('popup.amenityHasNoAvailableDates'),
            false,
          );
        return dispatch({
          type: GET_RESERVED_DATES_SUCCESS,
          amenityId,
          res,
        });
      },
      (err) =>
        dispatch({
          type: GET_RESERVED_DATES_FAILURE,
          err,
        }),
    ),
  });

export const getAllowedHours = (dispatch, amenityId, date, reservationId) => {
  const reservation = reservationId || null;
  return dispatch({
    type: GET_ALLOWED_HOURS_REQUEST,
    payload: apiClient.amenity
      .getAllowedHours(amenityId, { date, reservation })
      .then(
        (res) =>
          dispatch({
            type: GET_ALLOWED_HOURS_SUCCESS,
            amenityId,
            res,
          }),
        (err) =>
          dispatch({
            type: GET_ALLOWED_HOURS_FAILURE,
            err,
          }),
      ),
  });
};

const uploadAmenityLogo = (dispatch, icons, res) => {
  if (!icons?.length || icons?.[0]?.url) return null;
  const amenityId = res?.data?.id;
  const url = `amenities/${amenityId}/image/`;
  return uploadImage(dispatch, icons, url);
};

const deleteAmenityLogo = (dispatch, res, fileId) => {
  const amenityId = res?.data?.id;
  return dispatch({
    type: DELETE_AMENITY_IMAGE,
    isForm: true,
    payload: apiClient.amenity.deleteAmenityImage(amenityId, fileId).then(
      async (res) => {
        dispatch({
          type: DELETE_AMENITY_IMAGE_SUCCESS,
          res,
        });
      },
      (err) => {
        dispatch({
          type: DELETE_AMENITY_IMAGE_FAILURE,
          err,
        });
        return err;
      },
    ),
  });
};

export const createAmenity = (dispatch, data) => {
  const { images, ...rest } = data;
  return dispatch({
    type: CREATE_AMENITY_REQUEST,
    isForm: true,
    payload: apiClient.amenity.createAmenity(rest).then(
      async (res) => {
        dispatch({
          type: CREATE_AMENITY_SUCCESS,
          res,
        });
        await uploadAmenityLogo(dispatch, images, res);
        return history.goBack();
      },
      (err) => {
        dispatch({
          type: CREATE_AMENITY_FAILURE,
          err,
        });
        return err;
      },
    ),
  });
};

export const updateAmenity = (dispatch, data, imageIdToRemoved = []) => {
  const { images, id, ...rest } = data;
  return dispatch({
    type: UPDATE_AMENITY_REQUEST,
    isForm: true,
    payload: apiClient.amenity.updateAmenity(id, rest).then(
      async (res) => {
        dispatch({
          type: UPDATE_AMENITY_SUCCESS,
          res,
        });

        await Promise.all(
          imageIdToRemoved.map(async (imageIdToDelete) => {
            await deleteAmenityLogo(dispatch, res, imageIdToDelete);
          }),
        );

        const uploadImages = images?.filter(({ id }) => !id) ?? [];
        uploadImages.length &&
          (await uploadAmenityLogo(dispatch, uploadImages, res));

        return history.goBack();
      },
      (err) => {
        dispatch({
          type: UPDATE_AMENITY_FAILURE,
          err,
        });
        return err;
      },
    ),
  });
};

export const confirmAction = (dispatch, bodyText, data, callback) => {
  const modalProps = {
    bodyText,
    onConfirm: () => callback(dispatch, data),
  };
  dispatch({
    type: SET_MODAL_TYPE,
    modalType: CONFIRM,
    modalProps,
  });
};

export const updateAmenityStatus = (dispatch, data) => {
  const { listParams, id, ...rest } = data;
  return dispatch({
    type: UPDATE_AMENITY_REQUEST,
    payload: apiClient.amenity.updateAmenityStatus(id, rest).then(
      (res) => {
        dispatch({
          type: UPDATE_AMENITY_SUCCESS,
          res,
        });
        return getAmenities(dispatch, listParams);
      },
      (err) =>
        dispatch({
          type: UPDATE_AMENITY_FAILURE,
          err,
        }),
    ),
  });
};

export const clearAmenities = (dispatch) => dispatch({ type: CLEAR_AMENITIES });

export const setAmenityStatus = (dispatch, id, status) =>
  dispatch({
    type: SET_AMENITY_STATUS_REQUEST,
    payload: apiClient.amenity.setAmenityStatus(id, status).then(
      (res) => {
        dispatch({
          type: SET_AMENITY_STATUS_SUCCESS,
          res,
        });
        return res;
      },
      (err) => dispatch({ type: SET_AMENITY_STATUS_FAILURE, err }),
    ),
  });

export const getDoors = (dispatch, queryParams, id) => {
  const params = { ...queryParams, disable_pagination: true };
  dispatch({
    type: GET_DOORS_AMENITY_REQUEST,
    payload: apiClient.building.getDoors(params, id).then(
      (res) => {
        dispatch({
          type: GET_DOORS_AMENITY_SUCCESS,
          res,
        });
        return res;
      },
      (err) => dispatch({ type: GET_DOORS_AMENITY_FAILURE, err }),
    ),
  });
};
